import { Vue } from 'vue-property-decorator';
import moment, { Moment } from 'moment';

Vue.filter('date', (value: Moment) => {
    if (value) {
        return moment(String(value)).format('MMMM D, YYYY');
    }
    return '';
});
